import { billing_vector } from "../../../../assets/index.js";
import styles from "./SaveUp.module.css";

const SaveUp = () => {
  return (
    <div
      className={styles.saveUpBlock}
      style={{
        backgroundImage: `url(${billing_vector})`
      }}
    >
      LIMITED TIME DISCOUNT
    </div>
  );
};

export default SaveUp;